import { addStyles } from 'ethcss'
import { grid, IStyles, mediaCSS } from '../../../theme'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'

const fontAddStyles: IStyles = {
    root: {
        maxHeight: '85vh', // модалка всегда в пределах экрана
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        fontSize: 20,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 24,
    },
    infoIcon: {
        width: 18,
        height: 18,
        borderRadius: '50%',
        border: '1px solid #ccc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        cursor: 'pointer',
    },
    upload: {
        marginBottom: 24,
    },
    label: {
        fontSize: 14,
        marginBottom: 8,
    },
    uploadRow: {
        display: 'flex',
        gap: 12,
    },
    input: {
        flex: 1,
        height: 40,
        padding: '0 12px',
        border: '1px solid #ddd',
        borderRadius: 8,
    },
    button: {
        height: 40,
        padding: '10px 16px',
        borderRadius: 20,
        border: '1px solid #aaa',
        background: '#fff',
        cursor: 'pointer',
        textAlign: 'center',
    },
    list: {
        border: '1px solid #eee',
        borderRadius: 12,
        marginBottom: 24,
        display: 'flex',
        flexDirection: 'column',
    },
    listHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 12,
        background: '#f6f6f6',
    },
    listTitle: {
        flex: 1,
        fontWeight: 500,
    },
    delete: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.6,

        '&:disabled': {
            opacity: 0.3,
            cursor: 'default',
        },
    },
    itemsWrapper: {
        maxHeight: '40vh', // подбирается под дизайн
        overflowY: 'auto',
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 12px',
        borderTop: '1px solid #eee',
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
        gap: 12,
    },
    secondary: {
        padding: '10px 20px',
        borderRadius: 20,
        border: '1px solid #ddd',
        background: '#fff',
    },
    primary: {
        padding: '10px 20px',
        borderRadius: 20,
        border: 'none',
        background: '#ccc',
    },
    headerIcons: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    modalSaveApprove: {
        position: 'absolute',
        top: 'calc(100% + 8px)',
        right: 0,
        transform: 'translate(50%)',
        width: 260,
        padding: '12px 14px',
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08)',
        fontSize: 14,
        lineHeight: '1.4',
        color: '#111',
        zIndex: 10,
        textAlign: 'center',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: -6,
            right: 'calc(50%)',

            width: 12,
            height: 12,

            background: '#fff',
            transform: 'rotate(45deg)',

            boxShadow: '-1px -1px 1px rgba(0, 0, 0, 0.05)',
        },
    },
}

addStyles(fontAddStyles)
export default fontAddStyles
